import type { Page, PageRequest, PageResponse, Response } from '@/types'
import type {
  AwardDescInfoRes,
  CommissionProportion,
  DetailRes,
  InviteImageRes,
  InviteLinkUrl,
  InvitationCodeDomain,
  InviteMobileRes,
  InviteRuleRes,
  InviteSmsRes,
  LogRes,
  MemberRes,
  ShareDetail,
  ShareDetailAggResponse,
  ShareProgressData,
  ShareRollingData,
  SmsAggResponse,
  TeamRes
} from '@/types/share'
import { http } from '@/utils/http'

// 分享赚钱-短信手机列表
export const inviteMobile = async () => {
  return await http<Response<InviteMobileRes[]>>('/app-api/agent/share/invite/mobile', {
    method: 'post'
  })
}

// 分享赚钱-短信邀请
export const inviteSms = async (params: { model: { type: number }; size: number }) => {
  return await http<PageResponse<InviteSmsRes>>('/app-api/agent/share/invite/sms', {
    method: 'post',
    body: params
  })
}

// 分享赚钱-会员管理
export const member = async (
  body: PageRequest<{
    username?: string
    category?: number
  }> = {}
) => {
  return await http<PageResponse<MemberRes>>('/app-api/agent/share/member', {
    method: 'post',
    msgType: 'simpleToast',
    body
  })
}

// 分享赚钱-我的团队
export const team = async (data: {
  category?: number
  startTime?: string | number
  endTime?: string | number
}) => {
  return await http<Response<TeamRes>>('/app-api/agent/share/team', {
    method: 'post',
    body: data
  })
}

// 分享赚钱-佣金记录
export const agentSharelog = async (
  body: PageRequest<{
    awardCode?: string
    startTime?: number
    endTime?: number
  }> = {}
) => {
  return await http<PageResponse<LogRes>>('/app-api/agent/share/log', {
    method: 'post',
    body
  })
}

// 分享赚钱-佣金记录总计
export const logSum = async (body?: {
  model: {
    startTime?: number
    endTime?: number
  }
}) => {
  return await http<Response<string>>('/app-api/agent/share/log/sum', {
    method: 'post',
    body
  })
}

// 分享赚钱-详情
export const getShareDetail = async () => {
  return await http<Response<DetailRes>>('/app-api/agent/share/detail', {
    method: 'post'
  })
}

// 滚动数据
export const getShareRollingData = async () => {
  return await http<Response<ShareRollingData[]>>('/app-api/agent/share/rolling', {
    method: 'post'
  }).then((res) => {
    res.data?.forEach((it, index) => {
      it.avatar = `/img/avatars/fake-head (${(index % 30) + 1}).webp`
    })

    return res
  })
}

// 刷新域名
export const getDomainRefresh = async () => {
  return await http<Response<string>>('/app-api/agent/share/domain/refresh', {
    method: 'post'
  })
}

// 领取佣金
export const getRewards = async () => {
  return await http<Response<boolean>>('/app-api/activity/order/receiveCommission', {
    method: 'post',
    showLoading: true
  })
}

// 分享进度数据
export const getShareProgressData = async (body?: { startTime: number; endTime: number }) => {
  return await http<Response<ShareProgressData>>('/app-api/agent/share/memberResult', {
    method: 'post',
    body
  })
}

// 分享赚钱-邀请规则
export const shareInviteRule = async () => {
  return await http<Response<InviteRuleRes>>('/app-api/agent/share/inviteRule', {
    method: 'post'
  })
}

// 分享赚钱-邀请规则
export const shareAwardDesc = async () => {
  return await http<Response<AwardDescInfoRes>>('/app-api/agent/share/awardDesc/info', {
    method: 'post'
  })
}

// 分享赚钱-邀请好友，佣金比例
export const shareCommissionProportion = async () => {
  return await http<Response<CommissionProportion[]>>(
    '/app-api/agent/share/commissionProportion/info',
    {
      method: 'post'
    }
  )
}

// 分享赚钱-推广信息
export const shareDetail = async () => {
  return await http<Response<ShareDetail>>('/app-api/agent/share/detail', {
    method: 'post'
  })
}

// 分享赚钱-推广信息 - 保存联络方式
export const shareContactSave = async (body?: { tgUsername: string }) => {
  return await http<Response<boolean>>('/app-api/agent/share/contact/save', {
    method: 'post',
    body
  })
}

// 分享赚钱-海报邀请
export const shareInviteImage = async (body?: PageRequest) => {
  return await http<Response<Page<InviteImageRes>>>('/app-api/agent/share/invite/image', {
    method: 'post',
    body
  })
}

// 分享赚钱-海报邀请
export const shareInviteUrl = async (body?: PageRequest) => {
  return await http<Response<Page<InviteLinkUrl>>>('/app-api/agent/share/invite/url', {
    method: 'post',
    body
  })
}

// rebeate 分享赚钱-详情 agg
export const getShareDetailAggApi = async () => {
  return await http<Response<ShareDetailAggResponse>>('/app-api/index/sharerebate/agg', {
    method: 'post',
    data: {
      shareDetail: {},
      commissionProportionInfo: {}
    }
  })
}

// sms agg 接口
export const getMobileSmsAggApi = async (body?: { inviteMobile: object; inviteSms: object }) => {
  return await http<Response<SmsAggResponse>>('/app-api/index/sms/agg', {
    method: 'post',
    body
  })
}

export const apiListWithInvitationCode = async () => {
  return await http<Response<InvitationCodeDomain[]>>('/app-api/listWithInvitationCode', {
    method: 'post'
  })
}
